import { create } from "zustand";
import { CommentFormSlice, createCommentFormSlice } from "./comment-form-slice";
import { persist } from "zustand/middleware";
import {
  pageTransitionStateSlice,
  PageTransitionStateSlice,
} from "./transition-lock-slice";
import { authStateSlice, authenticationTypes } from "./login-state-slice";

// Slice - type
interface StoreState
  extends CommentFormSlice,
    authenticationTypes,
    PageTransitionStateSlice {}

// Store
const useStore = create<StoreState>()(
  persist(
    (...arg) => ({
      ...createCommentFormSlice(...arg),
      ...pageTransitionStateSlice(...arg),
      ...authStateSlice(...arg),
    }),
    {
      name: "portfolio-storage",
      partialize: (state) => ({ authentication: state.authentication }),
    }
  )
);

export default useStore;
